import { call } from 'redux-saga/effects';
import { parseQueryString } from '../../../../utils/helperFunctions';
import notify from '../../../helpers/notify';
import request from '../../../helpers/request';
import { SHOW_CUSTOMER_INDICATORS } from '../constants';

const getCustomerIndicatorNotifier = (params, loader = false) =>
  notify({
    type: SHOW_CUSTOMER_INDICATORS,
    params,
    loader,
  });

function* getCustomerIndicatorAction({ params }) {
  const strQueryParams = parseQueryString(params);
  yield call(request, {
    type: SHOW_CUSTOMER_INDICATORS,
    method: 'get',
    endpoint: `/indicators/getCustomers${strQueryParams}`,
  });
}

export { getCustomerIndicatorAction, getCustomerIndicatorNotifier };
